import { render, staticRenderFns } from "./SecondSupervisorReviews.vue?vue&type=template&id=5f8100e4&scoped=true"
import script from "./SecondSupervisorReviews.vue?vue&type=script&lang=js"
export * from "./SecondSupervisorReviews.vue?vue&type=script&lang=js"
import style0 from "./SecondSupervisorReviews.vue?vue&type=style&index=0&id=5f8100e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8100e4",
  null
  
)

export default component.exports